const kpop = require('kpop');
export default kpop.romanize;
